import React from 'react';

const Breadcrumbs = (props) => {
  const items = Object.keys(props?.fields)?.map((k, i) => {
    var x = props?.fields[k];
    return {
      name: x?.name,
      breadCrumb: x?.breadCrumb,
      link: x?.link,
      isLast: i === Object.keys(props?.fields).length - 1,
    };
  });

  // Skip the first item in the items list
  const breadcrumbItems = items.slice(1);

  return (
    <div className="banner-bread-crumbs">
      <nav
        aria-label="breadcrumb"
        style={{
          '--bs-breadcrumb-divider':
            "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='currentColor'/%3E%3C/svg%3E\")",
        }}
      >
        <ol className="breadcrumb">
          {[
            { name: 'Home', breadCrumb: 'Home', link: '/', isLast: false },
            ...(breadcrumbItems || []),
          ].map((item, i) => {
            const itemName =
              i === 1 ? 'ABCD' : item?.breadCrumb !== '' ? item?.breadCrumb : item?.name;
            return (
              <li
                key={`breadcrumb-key-${i}`}
                className={`breadcrumb-item ${item.isLast ? 'active' : ''}`}
              >
                {item.isLast ? itemName : <a href={item?.link}>{itemName}</a>}
              </li>
            );
          })}
        </ol>
      </nav>
    </div>
  );
};

export default Breadcrumbs;
